<template>
  <b-card class="border-0">
    <h4><b-icon icon="house-door" class="mr-2"/><translate>Office Address</translate></h4>
    <p>Calle Montaña Clara n°6, C.C. Laurisilva Local 6 I, 38679, Adeje, Tenerife</p>
  </b-card>
</template>

<script>
export default {
  name: 'footerAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
